import axios from 'axios'
const API_URL = process.env.VUE_APP_PDF_RENDERING
const COGNITO_URL = process.env.COGNITO_URL
const GENUS_URL = process.env.GENUS_URL
class PdfRendringService {

  getCognitoToken(clientID, clientSecret) {
    const data = `grant_type=client_credentials&client_id=${clientID}&client_secret=${clientSecret}`;
    return axios.post(`${COGNITO_URL}`, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  };

  getPeriodValue(token, period, clientRut, beneficiaryRut) {
    if (period && (!clientRut && !beneficiaryRut)) {
      return axios.post(`${API_URL}Monitoring/GetByPeriod?periodo=${period}`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    } else {
      return axios.post(`${API_URL}Monitoring/GetByIds`, {
        period: period,
        clientRut: clientRut,
        beneficiaryRut: beneficiaryRut
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      })
    }
  };

  getGenusPdfUrl(intInstruccion, intSecuencia, intSeqRegistro) {
    const formData = new URLSearchParams();
    formData.append("intInstruccion", intInstruccion);
    formData.append("intSecuencia", intSecuencia,);
    formData.append("intSeqRegistro", intSeqRegistro);
    formData.append("Tipo", 1);

    return axios.post(`${GENUS_URL}ConsultaPagosEfectuados/GenerarComprobante`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  };

  getIPSServiceData(token, period, clientRut) {
      return axios.post(`${API_URL}Monitoring/GetIPSResponse`, {
        period: period,
        clientRut: clientRut
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
  };

  getExportTodoCVS(token, period) {
    return axios.post(`${API_URL}Admin/GetCSVFileDataByPeriod`, {
      period: period,
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  };

  getExportSelectionCVS(token, period, rutCliente, rutBeneficiario) {
    return axios.post(`${API_URL}Admin/GetCSVFileDataByRut`, {
      period: period,
      rutCliente: rutCliente,
      rutBeneficiario: rutBeneficiario
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  };

  getAdminExportSelectionCVS(token, formData) {
    return axios.post(`${API_URL}Admin/GetCSVFileDataByFilter`,  formData , {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
  }

  getAdminProcess(token, period) {
    return axios.post(`${API_URL}Admin/GetBatchIdByPeriod?period=${period}`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  }

  sendAdminProcess(token, processPeriod, BatchId) {
    return axios.post(`${API_URL}Admin/TriggerFromWidgetStepFunction`, {
      "Period": processPeriod,
      "BatchId": BatchId,
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  }

  sendAdminReprocessByFilter(token, reprocessFormFilters) {
    return axios.post(`${API_URL}Admin/ReprocessingData`, reprocessFormFilters, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
  }

  getProcessedBatchIds(token, period) {
    return axios.post(`${API_URL}Admin/GetProcessedBatchIds?period=${period}`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  }

  getLatestProcessId(token, period, batchId) {
    return axios.post(`${API_URL}Admin/GetLatestProcessIdByPeriodAndBatchId`, {
      period: period,
      batchId: batchId
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  }


  getProcessingSummaryData(token, formData) {
    return axios.post(`${API_URL}Admin/GetProcessingTableData`,  formData , {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
  }

  sendAdminReprocess(token, reprocessPeriod, selectedReprocessBatchId, selectedReprocessProcessId) {
    return axios.post(`${API_URL}Admin/TriggerReprocessStepFunction`, {
      "Period": reprocessPeriod,
      "BatchId": selectedReprocessBatchId,
      "ProcessId": selectedReprocessProcessId
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
  }
}


export default new PdfRendringService();



// WEBPACK FOOTER //
// ./src/services/PdfRendringService.js